/**
 * Capture UTM query params from the current URL and persist them
 * in a first-party cookie so the gateway (crm.foxia.vn) and the
 * bare domain (foxia.vn) share the same attribution data.
 *
 * Cookie format: querystring-encoded key=value pairs
 *   e.g. utm_source=google&utm_medium=cpc
 *
 * This mirrors the server-side UTMCookieMiddleware in the Go gateway.
 */

const COOKIE_NAME = "foxia_utm_info";
const COOKIE_DOMAIN = ".foxia.vn";
const COOKIE_MAX_AGE_DAYS = 30;

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

export function captureUTMCookie(): void {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);

  const utmPairs: string[] = [];
  for (const key of UTM_KEYS) {
    // Support case-insensitive param names (e.g. UTM_Source)
    for (const [k, v] of params.entries()) {
      if (k.toLowerCase() === key && v) {
        utmPairs.push(`${key}=${encodeURIComponent(v)}`);
        break;
      }
    }
  }

  if (utmPairs.length === 0) return;

  const value = utmPairs.join("&");
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;

  document.cookie = `${COOKIE_NAME}=${value}; Domain=${COOKIE_DOMAIN}; Path=/; Max-Age=${maxAge}; SameSite=Lax`;
}
